kombi.copyTransferArea = function (event) {
    const copyElement = event.target.closest('.copy-div');
    const copyText = copyElement.querySelector('.copy-text');
    const transferArea = document.createElement("textarea");

    transferArea.value = copyText.innerText;
    document.body.appendChild(transferArea);
    transferArea.select();

    navigator.clipboard.writeText(transferArea.value)
        .then(() => {
            if (event.target.matches('button.copy-button') || event.target.closest('button.copy-button')) {
                const btn = event.target.closest('button.copy-button');
                if (btn) {
                    const btnText = btn.querySelector('span');
                    btnText.textContent = 'Copiado!';
                    btn.classList.remove('btn-primary');
                    btn.classList.add('btn-success', 'text-white');
                }
            }
        })
        .catch(function (err) {
            console.error('Erro ao copiar para a área de transferência:', err);
        })
        .finally(function () {
            document.body.removeChild(transferArea);
            const copiedElement = copyElement.querySelector('.copy-check') || document.querySelector('.copy-check');

            if (copiedElement) {
                copiedElement.classList.remove("d-none", "fade-out");
                copiedElement.classList.add("fade-in");

                setTimeout(function () {
                    copiedElement.classList.remove("fade-in");
                    copiedElement.classList.add("fade-out");

                    setTimeout(function () {
                        copiedElement.classList.add("d-none");
                    }, 500);
                }, 2000);
            }
        });
};
